<template>
    <div>
        <Navbar/>
        <div class="signin__wrap">
        <section class="section__signin">
            <div class="container">
                <div class="row align-items-center">
                    <div class="col-xxl-5 col-xl-5 col-lg-4 col-md-4 d-md-block d-sm-none d-none">
                        <img src="@/assets/images/signin__img.png" alt="img" class="signin__img">
                    </div>
                    <div class="col-xxl-4 col-xl-4 col-lg-5 col-md-6 offset-xxl-2 offset-xl-2 offset-lg-2 offset-md-2">
                        <h2 class="signin__title"><strong>{{$t('school_in')}}</strong></h2>
                        <form @submit.prevent="handleSubmit">

                            <div class="signin__inputs">
                              <div class="input__group" @click="isFocus = 1" :class="{'focus': isFocus === 1 || username}">
                                <label for="signin__login">{{$t('login')}}</label>
                                <input type="text" v-model="username" id="signin__login" @input="checkForInput">
                              </div>
                              <div class="input__group" @click="isFocus = 2" :class="{'focus': isFocus === 2 || password}">
                                <label for="signin__password">{{$t('password')}}</label>
                                <input v-model="password" id="signin__password" @input="checkForInput" :type="isVisible ? 'text' : 'password'">
                                <span class="input__pass__toggle" @click="inputShowPassword" :class="{visible: isVisible}"></span>
                              </div>
<!--                                <div class="input__group">-->
<!--                                    <label for="signin__login" v-if="!username">{{$t('login')}}</label>-->
<!--                                    <input v-model="username" type="text" id="signin__login">-->
<!--                                </div>-->
<!--                                <div class="input__group">-->
<!--                                    <label for="signin__password">{{$t('password')}}</label>-->
<!--                                    <input v-model="password" type="password" id="signin__password">-->
<!--                                    <span class="input__pass__toggle"></span>-->
<!--                                </div>-->
                                <div class="signin__settings">
                                    <div class="signin__remember">
                                        <input v-model="rememberMe" type="checkbox" class="checkbox" id="signin__remember__checkbox">
                                        <label for="signin__remember__checkbox" class="signin__remember__label">{{$t('remember_me')}}</label>
                                    </div>
                                    <div class="signin__forgot">
                                        <a href="/faq" class="signin__forgot__link">{{$t('forgot_log_or_pas')}}</a>
                                    </div>
                                </div>
                                <div style="padding-top: 30px">
                                    <label style="font-size: 0.75rem">
                                        {{$t('police_agree1')}} <a href="/landing/policy">{{$t('police_agree2')}}</a>
                                    </label>
                                </div>

                            </div>

                            <button class="signin__button lg__button">{{$t('log_in')}}</button>
                        </form>
                        <a class="lg__button empty signin__teachers" @click="loginWithEkyzmat">{{$t('ekyzmatAuth')}}</a>
                    </div>
                </div>
            </div>
        </section>
        </div>
    </div>
<!--    <div class="login-container">-->
<!--        <div class="head-text">-->
<!--            <router-link to="/" class="home-btn">-->
<!--                <img src="@/assets/images/landing/next.svg" class="left" alt="next">-->
<!--                <span class="to-home-page">{{ $t('mainPage') }}</span>-->
<!--            </router-link>-->
<!--            <div class="top">{{ $t('minEducation') }}</div>-->
<!--            <div class="bottom">{{ $t('automatedSystemSmartSchool') }}</div>-->
<!--        </div>-->

<!--        <div class="login-page">-->
<!--            <PreLoader v-if="isLoading"/>-->
<!--            <div class="login-page__images">-->
<!--                <div>-->
<!--                    <img src="../../assets/images/background-image.svg">-->
<!--                </div>-->
<!--                <div class="globus-container">-->
<!--                    <img src="../../assets/images/globus.svg" width="120">-->
<!--                </div>-->
<!--            </div>-->
<!--            <div class="login-page__form">-->
<!--&lt;!&ndash;                <div class="login-with-esi" @click="loginWithESI">Войти через ЕСИА</div>&ndash;&gt;-->
<!--                <div class="login-page__form__head">-->
<!--                    {{ $t('signIn') }}-->
<!--                </div>-->
<!--                <form @submit.prevent="handleSubmit">-->
<!--                    <div class="login-page__form__item">-->
<!--                        <label>{{ $t('login') }}</label>-->
<!--                        <input-->
<!--                            v-model="username"-->
<!--                            name="username"-->
<!--                            :placeholder="$t('yourLogin')"-->
<!--                        >-->
<!--                    </div>-->
<!--                    <div class="login-page__form__item">-->
<!--                        <label>{{ $t('password') }}</label>-->
<!--                        <input-->
<!--                            v-model="password"-->
<!--                            :placeholder="$t('yourPassword')"-->
<!--                            type="password"-->
<!--                        >-->
<!--                    </div>-->
<!--                    <div>-->
<!--                        <div class="login-page__form__item center top-mg">-->
<!--                            <button>{{ $t('signIn') }}</button>-->
<!--                        </div>-->
<!--                        <div class="login-page__form__item center">-->
<!--                        </div>-->
<!--                    </div>-->
<!--                    <div class="login-page__form__footer">-->
<!--                        &lt;!&ndash;<div>Забыли пароль?</div>&ndash;&gt;-->
<!--                        &lt;!&ndash;<div>Регистрация</div>&ndash;&gt;-->
<!--                    </div>-->
<!--                </form>-->
<!--                <div>-->
<!--                    <div class="login-page__form__item center">-->
<!--                        <button @click="loginWithEkyzmat">{{ $t('signInViaEkyzmat') }}</button>-->
<!--                    </div>-->
<!--                </div>-->
<!--            </div>-->
<!--        </div>-->
<!--        <div class="supported-by">{{ $t('developerInfocom') }}</div>-->
<!--    </div>-->
</template>

<script>
import { mapActions, mapState } from 'vuex'
import EsiaService from '@/_services/esia.service'
import EkyzmatService from '@/_services/ekyzmat.service'
import Navbar from '@/views/landing/Navbar.vue'
import Footer from '@/views/landing/Footer.vue'

export default {
  components: {
    Footer,
    Navbar
  },
  data () {
    return {
      isLoading: false,
      username: '',
      password: '',
      rememberMe: false,
      show: false,
      isVisible: false,
      isFocus: false
    }
  },
  computed: {
    ...mapState('account', ['onError'])
  },
  beforeCreate () {
    const isInitial = window.sessionStorage.getItem('isInitial')
    if (!isInitial) {
      window.location.reload()
      window.sessionStorage.setItem('isInitial', true)
    }
  },
  methods: {
    ...mapActions('account', ['login', 'logout']),
    handleSubmit () {
      const { username, password } = this
      if (username && password) {
        this.isLoading = true
        this.login({ username, password })
      }
    },

    checkForInput (e) {
      const input = e.target
      if (input.value !== '') {
        input.parentNode.classList.add('focus')
      } else {
        input.parentNode.classList.remove('focus')
      }
    },

    inputShowPassword () {
      this.isVisible = !this.isVisible
    },

    loginWithESI () {
      this.isLoading = true
      EsiaService.authenticateWithESI().then((res) => {
        if (res.url.includes('ReturnUrl')) {
          window.location.href = res.url
        }
        this.isLoading = false
      }).catch((err) => {
        this.$toast.error(err)
        this.isLoading = false
      })
    },
    loginWithEkyzmat () {
      this.isLoading = true
      EkyzmatService.ekyzmatLogin()
    }
  },
  watch: {
    onError (message) {
      if (message) {
        this.isLoading = false
        this.$toast.error('Неправильный логин или пароль!')
        this.$store.state.account.onError = ''
      }
    }
  },
  mounted () {
    // eslint-disable-next-line camelcase
    function resize__screen () {
      const desktopScreen = window.innerHeight
      const headerHeight = document.getElementsByClassName('header')[0]?.offsetHeight
      document.getElementsByClassName('section__signin')[0].style.height = desktopScreen - headerHeight + 'px'
    }

    resize__screen()
    window.onresize = (event) => {
      resize__screen()
    }
  }

}
</script>
<style lang="scss" scoped>
//@import url('https://fonts.googleapis.com/css2?family=Inter&display=swap');
.login-container {
    position: relative;
    background: linear-gradient(180deg, #F6FAFD 0%, #FFFFFF 19.4%);
    .head-text {
        font-size: 19px;
        padding: 10px 0 0 12px;
        .top {
            padding: 7px 0;
            border-bottom: 1px solid #9f9f9f;
            color: #424242;
            margin-bottom: 3px;
        }
        .bottom {
            color: #1976d2;
        }
    }
    .home-btn {
        display: inline-flex;
        background: #fff;
        padding: 4px 12px;
        border-radius: 50px;
        border: 1px solid #eee;
        cursor: pointer;
        text-decoration: none;
        font-size: 15px;
        .left {
            transform: rotate(180deg);
            margin-right: 8px;
        }
        .to-home-page {
            background: #fff;
            font-size: 15px;
            color: #1976d2;
        }
        &:hover {
            border-color: royalblue;
        }
    }
    .supported-by {
        text-align: right;
        font-weight: bold;
        transform: translate(-20px, -30px);
    }
}
.login-page {
  font-family: 'Inter', sans-serif;
  /*background: linear-gradient(180deg, #F6FAFD 0%, #FFFFFF 19.4%);*/
  display: flex;
  align-items: center;
  justify-content: space-around;
  height: 100vh;
  &__images {
    div:first-child {
      margin-bottom: 100px;
    }
  }
  &__form {
    width: 540px;
    max-height: 667px;
    padding: 3rem;
    background: #FFFFFF;
    box-shadow: 5px 10px 50px rgba(16, 112, 177, 0.2);
    form {
      height: 100%;
    }
    &__head {
      font-weight: 500;
      font-size: 24px;
      line-height: 160%;
      color: #4B5D68;
    }
    &__item {
      letter-spacing: 0.04em;
      font-size: 16px;
      line-height: 30px;
      margin: 30px 0;
      input {
        width: 428px;
        border: 1px solid rgba(#356EAD, 0.4);
        box-sizing: border-box;
        border-radius: 10px;
        height: 51px;
        padding: 0 20px;
        font-weight: 300;
        color: #1F3F68;
        &::placeholder {
          color: rgba(#1F3F68, 0.2);
        }
      }
      label {
        color: rgba(#1F3F68, 0.8);
      }
      button {
        width: 344px;
        height: 52px;
        line-height: 26px;
        font-weight: 500;
        color: #FFFFFF;
        background: linear-gradient(180deg, #166EFF 0%, #281AC8 100%, #281AC8 100%);
        /* shadow1 */
        box-shadow: 5px 20px 50px rgba(16, 112, 177, 0.2);
        border-radius: 10px;
        &.cancel-btn {
          background: none;
          box-shadow: none;
          border-radius: 0;
          color: #1466ED;
          line-height: 26px;
        }
      }
      &.center {
        display: flex;
        justify-content: center;
        margin: 10px 0;
      }
      &.top-mg {
        margin-top: 40px;
      }
    }
    &__footer {
      display: flex;
      justify-content: space-between;
      color: #1466ED;
      font-weight: normal;
      font-size: 14px;
      line-height: 30px;
    }
    .login-with-esi {
        text-align: center;
        transform: translateY(-30px);
        /*color: #4B5D68;*/
        color: transparent;
        cursor: pointer;
    }
  }
}
.globus-container {
  position: absolute;
  left: 35px;
  bottom: 8%;
}
</style>
